import { actions } from 'react-redux-form';
import {
    disputeFollowUpModel,
    getFollowUpDetails,
    getFollowUpDetailsByType,
    setFollowUpError
} from "../../../../constants/model-reducers/external/invoice/dispute/dispute-followup.settings";
import { httpPost } from "../../../../utils/api.utils";
import moment from 'moment';
import { convertToLocalDateToUTCDate } from '../../../../utils/helpers.utils';


export const disputeFollowUpFormInitialState=disputeFollowUpModel;

const defaultState = ()=>({
    disputeFollowUpDetails:[],
    detailsFound: false,
    disputeFollowUpError: false
});

const initialState=defaultState();

export const disputeFollowUpAction = {
    getFollowUpDetailsById:(disputeId) => async(dispatch,state) => {
        var res = await httpPost(`external/dispute/getDisputeFollowUpById/${disputeId}`);   
        if(res.ok === false)
        {
            dispatch({
                type: setFollowUpError,
                disputeFollowUpError: false,
                disputeFollowUpDetails: []
            })
        } else {
            dispatch({
                type: getFollowUpDetails,
                data: res
            }); 
        }      
    },
    getFollowUpDetailsByType:(disputeId, type) => async(dispatch, state) => {
        var res = await httpPost(`external/dispute/getDisputeFollowUpByType/${disputeId}/${type}`);   
        if(res.ok === false)
        {
            dispatch(actions.reset('invoiceDisputeFollowUpForm.details'));
            dispatch(actions.reset('invoiceDisputeFollowUpForm.followUpDate')); 
            dispatch({
                type: getFollowUpDetailsByType,
                detailsFound: false
            }); 
        } else {
            dispatch(actions.change('invoiceDisputeFollowUpForm.details', res.Details));
            dispatch(actions.change('invoiceDisputeFollowUpForm.followUpDate',  res.FollowUpDate ? convertToLocalDateToUTCDate(res.FollowUpDate, false) : '')); 
            dispatch({
                type: getFollowUpDetailsByType,
                detailsFound: true
            });  

            if(!res.FollowUpDate) {
                dispatch({
                    type: getFollowUpDetailsByType,
                    detailsFound: false
                });  
            }
        }
    },
    saveFollowUpDetails:(id,type)=> async(dispatch, state) =>{
        const { invoiceDisputeFollowUpForm } = state().form;
        const { followUpDate, disputeId } = invoiceDisputeFollowUpForm
        var data = {
            ...invoiceDisputeFollowUpForm,
            followUpDate: followUpDate ? moment(followUpDate).toISOString(true) : moment(new Date()).toISOString(true) ,
        }
        var result = await httpPost(`external/dispute/saveDisputeFollowUp/${disputeId}`, data);  
        if (result.ok === false) {
            console.log("Failed")          
        }
        return result;
    }
}

export const reducer=(state,action)=>{
    state = state || initialState;
    switch(action.type) {
        case getFollowUpDetails:
            return {
                ...state,
                disputeFollowUpDetails: action.data
            } 
        case getFollowUpDetailsByType:
            return {
                ...state,
                detailsFound: action.detailsFound
            }  
        case setFollowUpError:
            return {
                ...state,
                disputeFollowUpError: action.disputeFollowUpError,
                disputeFollowUpDetails: action.disputeFollowUpDetails
            }      
        default:
            return state
    }
}
